import API from '../../services/api.svelte.js';
import dayjs from 'dayjs';
import 'dayjs/locale/es';




// store Promise to avoid multiple simultaneous API calls
let billingPromise;
let billing = [];
let updated_at = null;

export function search(config = {}, year = null, month = null) {

    let now = dayjs();

    if(!year)  year   = dayjs().year();
    if(month < 0) month  = dayjs().month();

    let month_int = parseInt(month);
    month         = month_int + 1;

    billingPromise = API.search('billing' + "/" + year + "/" + month, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pBilling => {
            billing = pBilling;
            updated_at = new Date();
            return billing;
        })
    ;

    return billingPromise;
}

export async function updateFromAWS(){
    return API.save('v2/subscription_aws/sync')
            .then(async (response) => {
                if (!response.ok) {
                    let errors = await response.json();
                    let toastConfig = {
                        data: "",
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }
                    }
                    notificate('save_error', "toast", toastConfig);
                    throw errors;
                }
                else {
                    return await response.json();
                }
            })
            .then(apiData => {
                return apiData;
            })
        ;
}

export default {
    search,
    updateFromAWS
}
